import React, { useState } from 'react'
import { FiEdit } from 'react-icons/fi'
import { RiDeleteBinLine } from 'react-icons/ri'
import { apiV1 } from '../../../utils/api'
import { PopUp } from '../../Resources'
import TableV1 from '../../Resources/TableV1/TableV1'
import TitleContainer from '../../Resources/TitleContainer/TitleContainer'
import classes from './CategoryList.module.css'

export default function CategoryList(props) {
    const [newName, setNewName] = useState('')
    const [id, setId] = useState('')
    const [sl, setSl] = useState('')
    const [option, setOption] = useState('0')

    const handleEdit = () => {
        const url = `${apiV1}/categories/${id}`
        const status = 'category updated'
        const method = 'PUT'
        props.handleClick(url, newName, method, status)
    }

    const handleDelete = () => {
        const url = `${apiV1}/categories/${id}`
        const url2 = `${apiV1}/categories/sub_category/${id}`
        const status = 'category deleted'
        const status2 = 'Please remove the sub category of this category first!'
        const method = 'DELETE'
        props.handleClick(url, newName, method, status, url2, status2)
    }

    return (
        <div className={classes.wrapper}>
            <TitleContainer title={'Category List'} isCount={true} count={props.category?.length} />
            <TableV1>
                <thead>
                    <tr className={`${classes.tableRow}`}>
                        <th>Id</th>
                        <th>Category List</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>

                <tbody>
                    {props.category &&
                        props.category.map((data, index) => (
                            <tr className={classes.row} key={index}>
                                <td>{data.id}</td>
                                <td>
                                    {data.name}

                                    {props.clickEdit && sl === index && (
                                        <>
                                            {' -> '}
                                            <input
                                                className={classes.categoryInput}
                                                type="text"
                                                placeholder="Enter new name"
                                                value={newName}
                                                onChange={(e) => setNewName(e.target.value)}
                                            />
                                        </>
                                    )}
                                </td>

                                <td>
                                    {!props.clickEdit && (
                                        <FiEdit
                                            className={classes.icon}
                                            onClick={() => {
                                                props.setClickEdit(true)
                                                setId(data.id)
                                                setSl(index)
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    )}

                                    {props.clickEdit && sl === index && (
                                        <div className={classes.EditButton}>
                                            {newName && (
                                                <div
                                                    className={classes.save}
                                                    onClick={() => {
                                                        handleEdit()
                                                    }}>
                                                    Save
                                                </div>
                                            )}
                                            <div
                                                className={classes.cancel}
                                                onClick={() => {
                                                    props.setClickEdit(false)
                                                    setNewName('')
                                                }}>
                                                Cancel
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td>
                                    {
                                        <RiDeleteBinLine
                                            className={classes.iconDelete}
                                            onClick={() => {
                                                // setClickEdit(true)
                                                props.setActivePopUp(true)
                                                setId(data.id)
                                                setSl(index)
                                                setOption('1')
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    }
                                    {props.activePopUp && sl === index && option === '1' && (
                                        <PopUp
                                            setActivePopUp={props.setActivePopUp}
                                            btnClickPopUp={'2'}
                                            message={'Are you confirm?'}
                                            handleDelete={handleDelete}
                                            categoryId={data.id}
                                        />
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </TableV1>

            {/* {show && <Edit setShow={setShow} />} */}
            {/* {show && <PopUP setShow={setShow} userId={userID} isActive={isActive} />} */}

            {/* <Pagination pageSkip={pageSkip} setPageSkip={setPageSkip} listItem={sellers} pageAll={pageAll} /> */}
        </div>
    )
}
